import type { ConnectionInterface } from 'store/connections/types';
import type { PortsMapInterface, UnitInterface } from 'store/units/types';
import { PortMode } from 'store/units/types';
import { getDefaultPorts } from 'store/units/setAddUnitPorts';

/**
 *
 * @param unit the inserted unit
 * @param connection the connection that the unit should be inserted on
 * @param fromUnit connection start unit
 * @param toUnit connection end unit
 * @returns
 *   portsMap: The new ports for the unit
 *   connections: The new connections created by "spliting" the connection
 *   loc: The new location of the node
 */
export const interposeNode = (
  unit: UnitInterface,
  connection: ConnectionInterface,
  fromUnit: UnitInterface,
  toUnit: UnitInterface,
): {
  portsMap: PortsMapInterface;
  connections: ConnectionInterface[];
} => {
  const newUnitPorts = getDefaultPorts(unit.key, unit.layout);

  const newPortsMap: PortsMapInterface = {
    [unit.key]: newUnitPorts,
  };

  const insertedUnitInputPort = newPortsMap[unit.key].find(
    (p) => p.portMode === PortMode.INPUT,
  );
  const insertedUnitOutputPort = newPortsMap[unit.key].find(
    (p) => p.portMode === PortMode.OUTPUT,
  );

  if (!insertedUnitInputPort || !insertedUnitOutputPort) {
    return {
      portsMap: {},
      connections: [],
    };
  }

  const inputConnection: ConnectionInterface = {
    from: fromUnit.key,
    to: unit.key,
    fromPort: connection.fromPort,
    toPort: insertedUnitInputPort.key,
    key: `${connection.fromPort}${insertedUnitInputPort.key}`,
    conveyorCalc: false,
  };

  const outputConnection: ConnectionInterface = {
    from: unit.key,
    to: toUnit.key,
    fromPort: insertedUnitOutputPort.key,
    toPort: connection.toPort,
    key: `${insertedUnitOutputPort.key}${connection.toPort}`,
    conveyorCalc: false,
  };

  const newConnections: ConnectionInterface[] = [
    inputConnection,
    outputConnection,
  ];

  return {
    portsMap: newPortsMap,
    connections: newConnections,
  };
};
